export default "__VITE_ASSET__11549839__"